import i18n from "@helpers/lib/i18n";
import pluralize from "pluralize";
import type { EXAM_STATUS } from "types/tag";

export const taskCardBodyTemplate = ({
	isDiagonstic,
	isDailyProgress,
	diagnosticLabel,
	practiceTestsLabel,
}: {
	isDiagonstic?: boolean;
	isDailyProgress?: boolean;
	diagnosticLabel?: Record<string, string>;
	practiceTestsLabel?: string;
}): Record<EXAM_STATUS, string> => {
	if (isDailyProgress) {
		return {
			NOT_STARTED:
				"Revisit previous topics that you may have struggled with to keep your knowledge sharp",
			ACTIVE:
				"Continue to revisit previous topics that you may have struggled with to keep your knowledge sharp",
			COMPLETE: "",
			LEGACYREPORT: "",
			MIGRATEDREPORT: "",
		};
	}
	return {
		NOT_STARTED: isDiagonstic
			? `Take ${diagnosticLabel ? diagnosticLabel[i18n.language] : "free diagnostic"} to become familiar with the exam format`
			: `Try a full-length ${pluralize.singular(practiceTestsLabel?.toLocaleLowerCase() || "practice test")} to check your exam readiness.`,
		ACTIVE: "Complete your in-progress assessment",
		COMPLETE: "Review your performance and answers",
		LEGACYREPORT: "",
		MIGRATEDREPORT: "",
	};
};
